/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */
import { ResourceType } from './ResourceType';

/**
 * Enumeration of integration resource properties.
 */
export class IntegrationResourceProps {
  static REPRESENTATIVES_INTEGRATION = new IntegrationResourceProps(
    'representatives',
    'parties/representatives',
    'role',
    ResourceType.COMMON,
  );
  static APPLICANTS_INTEGRATION = new IntegrationResourceProps(
    'applicants',
    'parties/applicants',
    'role',
    ResourceType.COMMON,
  );

  static AGENTS_INTEGRATION = new IntegrationResourceProps('agents', 'parties/agents', 'role', ResourceType.COMMON);

  static configurations = [IntegrationResourceProps.REPRESENTATIVES_INTEGRATION, IntegrationResourceProps.APPLICANTS_INTEGRATION, IntegrationResourceProps.AGENTS_INTEGRATION];

  constructor(name, path, category, type) {
    this.name = name;
    this.path = path;
    this.category = category;
    this.type = type;
  }

  toString() {
    return `${this.name}`;
  }
}
